.container {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  width: 100%;
  background: var(--color-grey-9);

  // Border between the two videos
  &:before {
    content: '';
    position: absolute;
    background-color: #7a829666;
    align-self: stretch;
    width: 1px;
    height: 100%;
    z-index: 1;
    left: 50%;
  }
}

.choose-video-version-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
